import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { AddressApi } from "../apis"


export const getAddresses = createAsyncThunk("address/getAddresses", async (payload) => {
  return await AddressApi.getAddresses(payload)
})
